import { createContext } from 'react';

const SidePanContext = createContext<SidePanContextType | undefined>(undefined);

export default SidePanContext;
